import AUTH_TOKEN from '../ActionTypes';
import REMOVE_AUTH_TOKEN from '../ActionTypes';

const initialState = {
  token: null,
};

export function AppReducer(state = initialState, action = {}) {
  switch (action.type) {
    case AUTH_TOKEN:
      return {
        ...state,
        token: action.payload,
      };
    case REMOVE_AUTH_TOKEN:
      return {
        ...state,
        token: null,
      };
    default:
      return state;
  }
}
